module.exports = {"230881001":"同江市城市管理委员会","230881100":"同江镇","230881101":"乐业镇","230881102":"三村镇","230881103":"临江镇","230881104":"向阳镇","230881105":"青河镇","230881204":"街津口乡","230881205":"八岔乡","230881206":"金川乡","230881207":"银川乡","230881400":"街津口林场","230881401":"鸭北林场","230881500":"勤得利农场","230881501":"青龙山农场","230881502":"前进农场","230881503":"洪河农场","230881504":"鸭绿河农场","230881505":"浓江农场","230881580":"良种场","230881581":"畜牧场","230881582":"知青农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230881.json
// module id = 708
// module chunks = 0